import { TypedUseSelectorHook, useSelector } from "react-redux";
import { GameState, gameActions } from "./GameReducer";
import { AppState, useAppDispatch } from "@grassrootly/rn-core";
import useBaseRequest from "../BaseRequest";
import { GetGameById, GetPlayerGameVotes } from "@grassrootly/api";

const useGameSelector: TypedUseSelectorHook<{ games: GameState } & AppState> = useSelector;

export const useLatestGame = () =>
  useGameSelector(({ games }) => {
    if (!games.latestGameId) return null;
    return games.games[games.latestGameId] || null;
  });

export const useGame = (id: number) => useGameSelector(({ games }) => games.games[id] || null);

export const useFetchGame = (id: number) => {
  const dispatch = useAppDispatch();
  const game = useGame(id);
  const { execute, loading } = useBaseRequest(GetGameById, {
    initialPayload: { id },
    autoFetch: true,
    onCompleted: (data) => {
      if (!data) return;
      dispatch(gameActions.setGame(data));
    },
  });

  const fetchGame = () => {
    execute({ id });
  };

  return { fetching: loading, fetchGame, game };
};

export const useGameVotes = (id: number) => useGameSelector(({ games }) => games.gameVotes[id] || null);

export const useFetchGameVotes = (id: number, gameId: number) => {
  const dispatch = useAppDispatch();
  const votes = useGameVotes(gameId);
  const { loading, execute } = useBaseRequest(GetPlayerGameVotes, {
    initialPayload: {
      id,
      gameId,
    },
    autoFetch: true,
    onCompleted: (data) => {
      dispatch(gameActions.setGameVotes({ gameId, votes: data }));
    },
  });

  const getVotes = () => {
    execute({ id, gameId });
  };

  return { loading, votes, getVotes };
};
